import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MODELS } from '../../../../../Apis/Models';
import mobileIcon from '../../../../../assets/icon/ic-mobile.svg';
import chevron_right_solid from '../../../../../assets/images/chevron-right-solid.svg';
import icLaptop from '../../../../../assets/images/ic-laptop.svg';
import searchVar from '../../../../../utils/SearchVar';
import { allowedModuleIdsApp, allowedModuleIdsWeb } from '../Model/AllowedModules';
import CustomAccordion from './../../../../../components/Accordion/CustomAccordion';
import DraggableBox from './DraggableBox';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const AvailableRole = ({ mobileAvailableList, websiteAvailableList, onHandler }) => {
    const { t } = useTranslation();
    const [activeParentKey, setActiveParentKey] = useState(null);
    const [activeChildKey, setActiveChildKey] = useState(null);
    // Handles role selection by passing the selected role to the parent handler.
    const handleRoles = (role) => {
        onHandler(role);
    };
    // Toggles the active parent accordion item.
    const handleParentSelect = (eventKey) => {
        setActiveParentKey((prev) => (prev === eventKey ? null : eventKey));
    };
    // Toggles the active child accordion item.
    const handleChildSelect = (eventKey) => {
        setActiveChildKey((prev) => (prev === eventKey ? null : eventKey));
    };
    // Returns the key (name) of a module from its module ID based on the MODELS mapping.
    const getKeyFromModuleId = (moduleId) => {
        return Object.entries(MODELS).find(([, id]) => id === moduleId)?.[0] || '';
    };

    return (
        <div>
            <CustomAccordion
                title={t('app')}
                header={
                    <span className='accordion-subtitle-roles'>
                        {t('app').toLocaleUpperCase()} <sub>{`(${mobileAvailableList?.length})`}</sub>
                        <img src={mobileIcon} alt='' />
                    </span>
                }
                button={null}
                currentKey='0'
                activeKey={activeParentKey}
                onSelect={handleParentSelect}
            >
                {allowedModuleIdsApp.map((moduleId) => {
                    const filteredRoles = mobileAvailableList.filter(
                        (role) => role.moduleId === moduleId && role.isMobileApp,
                    );

                    if (filteredRoles.length === 0) return null;

                    return (
                        <CustomAccordion
                            title={t(getKeyFromModuleId(moduleId))}
                            header={
                                <span className='accordion-item-roles'>
                                    {t(getKeyFromModuleId(moduleId)).toUpperCase()}
                                </span>
                            }
                            currentKey={moduleId.toString()}
                            activeKey={activeChildKey}
                            onSelect={handleChildSelect}
                        >
                            {filteredRoles.map((role) => (
                                <DraggableBox
                                    column='Available'
                                    type='box'
                                    index={role.id}
                                    className='infoDrop'
                                    selected={role}
                                    check={2}
                                    onClick={() => handleRoles({ selected: role, check: 2 })}
                                >
                                    <span>{t(searchVar(role?.name))}</span>
                                    <img
                                        src={chevron_right_solid}
                                        className='btn-hover-transparent'
                                    />
                                </DraggableBox>
                            ))}
                        </CustomAccordion>
                    );
                })}
            </CustomAccordion>

            <CustomAccordion
                title={t('web_app')}
                header={
                    <span className='accordion-subtitle-roles'>
                        {t('web_app').toLocaleUpperCase()} <sub>{`(${websiteAvailableList?.length})`}</sub>{' '}
                        <img src={icLaptop} alt='' />
                    </span>
                }
                button={null}
                currentKey='1'
                activeKey={activeParentKey}
                onSelect={handleParentSelect}
            >
                {allowedModuleIdsWeb.map((moduleId) => {
                    const filteredRoles = websiteAvailableList.filter((role) => role.moduleId === moduleId);
                    if (filteredRoles.length === 0) return null;

                    return (
                        <CustomAccordion
                            title={t(getKeyFromModuleId(moduleId))}
                            header={
                                <span className='accordion-item-roles'>
                                    {t(getKeyFromModuleId(moduleId)).toUpperCase()}
                                </span>
                            }
                            currentKey={moduleId.toString()}
                            activeKey={activeChildKey}
                            onSelect={handleChildSelect}
                        >
                            {filteredRoles.map((role) => (
                                <DraggableBox
                                    column='Available'
                                    type='box'
                                    index={role.id}
                                    className='infoDrop'
                                    selected={role}
                                    check={2}
                                    onClick={() => handleRoles({ selected: role, check: 1 })}
                                >
                                    <span>{t(searchVar(role?.name))}</span>
                                    <img
                                        src={chevron_right_solid}
                                        alt='action icon'
                                        className='btn-hover-transparent'
                                    />
                                </DraggableBox>
                            ))}
                        </CustomAccordion>
                    );
                })}
            </CustomAccordion>
        </div>
    );
};

export default AvailableRole;
